/** Support inbox shown in the contact section, guarantee, how-it-works, and footer. */
export const SUPPORT_EMAIL = 'support@stockdigital.shop'
